const state = {
  activeIndex: 1
};

export default state;
